import { FileTrigger } from 'react-aria-components';
import { ApplicationSuccessIcon } from './ApplicationSuccessIcon';
import { UploadButton } from './UploadButton';

type ProfilePictureUploadButtonProps = {
  file?: File;
  setFile: (file: File | undefined) => void;
  existingPicture?: string | null;
};

export const ProfilePictureUploadButton = (props: ProfilePictureUploadButtonProps) => {
  const { file, setFile, existingPicture } = props;

  return (
    <FileTrigger
      acceptedFileTypes={['image/png', 'image/jpg', 'image/jpeg']}
      onSelect={(e) => {
        const files = e ? Array.from(e) : [];
        setFile(files[0]);
      }}
    >
      {!file && !existingPicture && (
        <UploadButton
          text={'Upload a profile picture'}
          hintText='.jpeg or .png, At least 200x200px and under 10MB'
          defaultIcon={'user-01'}
          middleIcon='plus-circle'
        />
      )}
      {file && (
        <UploadButton
          text={'Looking good!'}
          hintText='.jpeg or .png, At least 200x200px and under 10MB'
          avatarUrl={URL.createObjectURL(file)}
          middleIcon={<ApplicationSuccessIcon width={20} height={20} />}
        />
      )}
      {!file && existingPicture && (
        <UploadButton
          text={'Looking good!'}
          hintText='.jpeg or .png, At least 200x200px and under 10MB'
          avatarUrl={existingPicture}
          middleIcon={<ApplicationSuccessIcon width={20} height={20} />}
        />
      )}
    </FileTrigger>
  );
};
